// extracted by mini-css-extract-plugin
export default {"carouselMain":"Slideshow_carouselMain__LpCZ4","mainLogo":"Slideshow_mainLogo__3KjQU"};